import { render, staticRenderFns } from "./ModalAddFeaturedRegion.vue?vue&type=template&id=76a4064c&scoped=true"
import script from "./ModalAddFeaturedRegion.vue?vue&type=script&lang=js"
export * from "./ModalAddFeaturedRegion.vue?vue&type=script&lang=js"
import style0 from "./ModalAddFeaturedRegion.vue?vue&type=style&index=0&id=76a4064c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a4064c",
  null
  
)

export default component.exports